import { useContext, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchCoachProfileByEmailId } from "../redux/Slices/profileSettingsSlice";
import { UnitContext } from "../hooks/UnitProvider";

const useFetchCoachProfile = () => {
  const dispatch = useDispatch();
  const { toggleUnit } = useContext(UnitContext);
  const { profileData } = useSelector((state) => state.profile);

  // Get both possible email IDs from localStorage
  const coachEmailId = localStorage.getItem("coachemail");
  const emailId = localStorage.getItem("userName");

  // Determine which email to use (coachemail takes priority)
  const emailToUse = coachEmailId || emailId;
  const coachId = profileData?.coachId;

  useEffect(() => {
    if (!coachId && emailToUse) {
      dispatch(fetchCoachProfileByEmailId({ emailId: emailToUse, toggleUnit }));
    }
    // We include emailToUse in dependencies to refetch if it changes
  }, [dispatch, emailToUse, coachId, toggleUnit]);
};

export default useFetchCoachProfile;
